import { render } from "./pca-dictionary-grid-ro.vue?vue&type=template&id=be5f6de0"
import script from "./pca-dictionary-grid-ro.vue?vue&type=script&setup=true&lang=js"
export * from "./pca-dictionary-grid-ro.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/contracts/print-contract/components/pca-dictionary-grid-ro.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "be5f6de0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('be5f6de0', __exports__)) {
    api.reload('be5f6de0', __exports__)
  }
  
  module.hot.accept("./pca-dictionary-grid-ro.vue?vue&type=template&id=be5f6de0", () => {
    api.rerender('be5f6de0', render)
  })

}


export default __exports__